import React from "react";

import {
  View,
  Text,
  StyleSheet,
  Dimensions,
  TextInput,
  TouchableOpacity,
} from "react-native";
import { globalFontStyle } from "../../../assets";
import Colors from "../../../assets/Color/Colors";
import Width from "../../../assets/Width";
import FastImage from "../../../common/FastImage";
import { isMobile } from "../../../utils/commonMethods";

import { offer_cross, offer_red, offer_success } from "../../../utils/images";
import {convert} from "../../../locale/translateText";

const CouponModal = ({ message, success, coupon, onPopUpClose }) => {
  return (
    <View>
      <View
        style={{
          marginHorizontal: 20,
          marginVertical: 20,
        }}
      >
        <TouchableOpacity onPress={onPopUpClose}>
          <FastImage
            style={{ height: 22, width: 22, alignSelf: "flex-end" }}
            source={offer_cross()}
          />
        </TouchableOpacity>

        <FastImage
          style={{ height: 50, width: 50, alignSelf: "center" }}
          source={success ? offer_success() : offer_red()}
        />
        <Text style={globalFontStyle.appFontSmallText}>
          `{coupon}` {convert(success ? "Applied" : "Not applied")}
        </Text>
        <Text
          style={[
            globalFontStyle.appFontHeading,
            { color: Colors.black, marginVertical: 7 },
          ]}
        >
          {message}
        </Text>
        <Text style={globalFontStyle.appFontSmallText}>
          {convert(success ? "Happy Trading!" : "Please try again!")}
        </Text>
      </View>
      <View>
        <TouchableOpacity
          onPress={onPopUpClose}
          style={[
            styles.proceedBtnContainer,
            !isMobile() ? { width: Width.width / 3 } : {},
          ]}
        >
          <Text
            style={[
              globalFontStyle.appFontSubTextBold,
              { color: Colors.tradexBlue },
            ]}
          >
              {convert("Proceed")}
          </Text>
        </TouchableOpacity>
      </View>
    </View>
  );
};

export default CouponModal;

const styles = StyleSheet.create({
  proceedBtnContainer: {
    borderTopWidth: 0.2,
    borderTopColor: "rgba(0, 0, 0, 0.5)",
    paddingVertical: 8,
    alignItems: "center",
    justifyContent: "center",
    marginTop: 20,
    width: Dimensions.get("window").width - 100,
  },
});
